import { render, staticRenderFns } from "./EmProcessoVistoriaComponent.vue?vue&type=template&id=fb4c21fe&scoped=true"
import script from "./EmProcessoVistoriaComponent.vue?vue&type=script&lang=js"
export * from "./EmProcessoVistoriaComponent.vue?vue&type=script&lang=js"
import style0 from "./EmProcessoVistoriaComponent.vue?vue&type=style&index=0&id=fb4c21fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4c21fe",
  null
  
)

export default component.exports